<div class="header">
  <h3>
    {{ (newDistributionRule ? 'coupons.rules.create' : 'coupons.rules.title') | translate }}
  </h3>
</div>

<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading || isStatusChange"></txp-loading>

<div class="messages">
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="LoadErrorMsg"
                 *ngIf="showLoadError">
        {{ 'coupons.rules.grid.edit.loadFailMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="SaveErrorMsg"
                 *ngIf="showSaveError">
        {{ 'coupons.rules.grid.edit.saveFailMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="SaveJobsErrorMsg"
                 *ngIf="showSaveJobsError">
        {{ 'coupons.rules.grid.edit.saveJobsFailMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="LoadCouponsMsg"
                 *ngIf="showCouponsLoadError">
        {{ 'coupons.rules.grid.edit.loadCouponsMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="LoadJobsMsg"
                 *ngIf="showJobLoadingError">
        {{ 'coupons.rules.grid.edit.loadJobsMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="LoadSegmentsMsg"
                 *ngIf="showSegmentsLoadError">
        {{ 'coupons.rules.grid.edit.loadSegmentsMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.SUCCESS"
                 data-qa-label="SaveSuccessMsg"
                 *ngIf="createDistributionRuleSuccess">
        {{ 'coupons.rules.grid.edit.saveRuleSuccessMsg' | translate }}
    </txp-message>
</div>

<form class="form-container" *ngIf="!showLoadError && !isLoading" [formGroup]="form">
    <div class="form-content">
        <div class="form-fields">
            <div class="name-and-status">
              <mat-form-field class="name">
                <mat-label>{{ 'coupons.rules.grid.fields.name' | translate }}</mat-label>
                <input formControlName="name"
                       data-qa-label="RuleNameInput"
                       matInput
                       required />
                <mat-error>
                  {{ 'form.error.required' | translate }}
                </mat-error>
              </mat-form-field>

              <div class="enabled">
                <mat-slide-toggle formControlName="enabled" data-qa-label="RuleEnabled">
                  {{ 'coupons.rules.grid.fields.enabled' | translate }}
                </mat-slide-toggle>
              </div>

              <div class="archived">
                <mat-slide-toggle formControlName="archived" data-qa-label="RuleArchived">
                  {{ 'coupons.rules.grid.fields.archived' | translate }}
                </mat-slide-toggle>
              </div>
            </div>

            <div class="items-and-count">
              <div class="items">

                <mat-form-field class="loyalty-item-type" *ngIf="loyaltyRule">
                    <mat-label>{{ 'coupons.rules.grid.fields.loyaltyItemType' | translate }}</mat-label>
                    <mat-select matInput
                                data-qa-label="LoyaltyItemType"
                                (selectionChange)="onLoyaltyItemTypeChange($event.value)"
                                formControlName="loyaltyItemType">
                        <mat-option *ngFor="let item of loyaltyItemTypes"
                                    [value]="item.value"
                                    class="option">
                            <div class="option-name">{{ item.label }}</div>
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        {{ 'form.error.required' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="items-input" [hidden]="loyaltyRule && !form.get('loyaltyItemType').value">
                  <mat-select matInput
                              required
                              #itemSelectInput
                              panelClass="custom-autocomplete-select event-select"
                              disableOptionCentering
                              class="items-select"
                              [ngClass]="{ 'hidden-select': itemSelectInput.panelOpen }"
                              multiple
                              (opened)="filterItems.focus()"
                              data-qa-label="ItemsSelect"
                              formControlName="items"
                              [(value)]="selectedItems"
                              placeholder="{{ 'coupons.rules.grid.fields.'+ (!loyaltyRule ? 'coupons': form.get('loyaltyItemType').value ==='LOYALTY_REWARDS' ? 'rewards': 'bonuses') | translate }}">
                    <mat-option
                      [hidden]="!itemsSearch"
                      disabled
                      value="">
                      <txp-loading [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading>
                      {{ 'coupons.rules.grid.loadingItems' | translate}}
                    </mat-option>
                    <mat-option *ngFor="let item of itemsList.filteredData"
                                [value]="item.id"
                                class="option">
                      <div class="option-name">{{ item.name }}</div>
                    </mat-option>
                  </mat-select>
                  <input
                    #filterItems
                    type="text"
                    matInput
                    [hidden]="!itemSelectInput.panelOpen"
                    formControlName="filterItems"
                    placeholder="{{ 'coupons.rules.grid.filterItems.' + (!loyaltyRule ? 'coupons': form.get('loyaltyItemType').value ==='LOYALTY_REWARDS' ? 'rewards': 'bonuses') | translate }}">
                  <mat-error>
                    {{ 'form.error.required' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <mat-form-field class="maxDistributionsPerUser" *ngIf="!loyaltyRule">
                <mat-label>{{ 'coupons.rules.grid.fields.maxDistributionsPerUser' | translate }}</mat-label>
                <input formControlName="maxDistributionsPerUser"
                       data-qa-label="MaxDistributionsPerUser"
                       matInput
                       txpIntegersOnly />
                <mat-error>
                  {{ 'form.error.required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <mat-form-field class="rule-type" [ngClass]="{ 'read-only': !newDistributionRule }">
              <mat-select matInput
                          required
                          data-qa-label="RuleTypeSelect"
                          formControlName="type"
                          [(value)]="selectedRuleType"
                          placeholder="{{ 'coupons.rules.grid.fields.type.title' | translate }}">
                <mat-option *ngFor="let ruleType of ruleTypes"
                            [value]="ruleType.value"
                            class="option">
                  <div class="option-name">{{ ruleType.label }}</div>
                </mat-option>
              </mat-select>
            </mat-form-field>

          <mat-form-field class="segments" *ngIf="form.get('type').value !== 'ONE_TIME'">
            <mat-select matInput
                        required
                        #segmentSelectInput
                        panelClass="custom-autocomplete-select event-select"
                        disableOptionCentering
                        class="segment-select"
                        [ngClass]="{ 'hidden-select': segmentSelectInput.panelOpen }"
                        multiple
                        (opened)="filterSegments.focus()"
                        data-qa-label="SegmentsSelect"
                        formControlName="segments"
                        [(value)]="selectedSegments"
                        placeholder="{{ 'coupons.rules.grid.fields.segments' | translate }}">
              <mat-option
                [hidden]="!segmentSearch"
                disabled
                value="">
                <txp-loading [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading>
                {{ 'coupons.rules.grid.loadingSegments' | translate }}
              </mat-option>
              <mat-option *ngFor="let segment of segmentsList.filteredData"
                          [value]="segment.id"
                          class="option">
                <div class="option-name">{{ segment.segmentName }}</div>
              </mat-option>
            </mat-select>
            <input
              #filterSegments
              type="text"
              matInput
              [hidden]="!segmentSelectInput.panelOpen"
              formControlName="filterSegments"
              placeholder="{{ 'coupons.rules.grid.filterSegments' | translate }}">
            <mat-error>
              {{ 'coupons.rules.grid.edit.segmentsRequired' | translate }}
            </mat-error>
          </mat-form-field>

          <ng-container *ngIf="form.get('type').value === 'ONE_TIME'">
            <txp-button
              [style]="buttonStyle.SECONDARY"
              *ngIf="!addingJob && !editingJob"
              class="add-job-btn"
              data-qa-label="AddJobButton"
              (click)="onToggleJobForm(); $event.preventDefault()">
              {{ 'coupons.rules.grid.edit.jobs.addBtn' | translate }}
            </txp-button>
        </ng-container>

          <ng-container *ngIf="form.get('type').value === 'RECURRING'">
            <div class="schedule-fields" formGroupName="schedule">
              <mat-form-field>
                <mat-label>{{ 'coupons.rules.grid.edit.schedule.timeZone' | translate }}</mat-label>
                <mat-select  #timeZone matInput
                             data-qa-label="TimeZoneSelect"
                             required
                             formControlName="timeZone">
                    <mat-option *ngFor="let timezone of timeZones" [value]="timezone.timeZoneCode">
                      {{ timezone.timeZoneName }}
                    </mat-option>
                </mat-select>
                <mat-error>
                  {{ 'form.error.required' | translate}}
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'coupons.rules.grid.edit.schedule.startDate' | translate }}</mat-label>
                <input matInput
                       [ngxMatDatetimePicker]="recurringStartDatePicker"
                       [matDatepickerFilter]="startDateFilter"
                       required
                       [min]="newDistributionRule ? minDate : null"
                       formControlName="startDate">
                <mat-datepicker-toggle matSuffix [for]="$any(recurringStartDatePicker)">
                </mat-datepicker-toggle>
                <ngx-mat-datetime-picker #recurringStartDatePicker
                                         [showSpinners]="true"
                                         [hideTime]="true"
                                         [color]="color"
                                         [enableMeridian]="true">
                    <ngx-mat-datepicker-actions>
                        <button color="primary" ngxMatDatepickerApply mat-icon-button
                            [attr.aria-label]="'form.button.select' | translate ">
                            <i class="tce-icon-checkmark"></i>
                        </button>
                    </ngx-mat-datepicker-actions>
                </ngx-mat-datetime-picker>
                <mat-error *ngIf="form.get('schedule.startDate').errors?.startAfterEnd">
                  {{ 'coupons.rules.grid.edit.schedule.startDateAfterEndError' | translate }}
                </mat-error>
                <mat-error *ngIf="!form.get('schedule.startDate').errors?.startAfterEnd && form.get('schedule.startDate').errors?.matDatetimePickerMin">
                  {{ 'coupons.rules.grid.edit.schedule.startDateMinError' | translate }}
                </mat-error>
                <mat-error *ngIf="!form.get('schedule.startDate').errors?.startAfterEnd && !form.get('schedule.startDate').errors?.matDatetimePickerMin && (form.get('schedule.startDate').errors?.required || form.get('schedule.startDate').errors?.invalid)">
                  {{ 'coupons.rules.grid.edit.schedule.startDateRequired' | translate }}
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'coupons.rules.grid.edit.schedule.endDate' | translate }}</mat-label>
                <input matInput
                       [ngxMatDatetimePicker]="recurringEndDatePicker"
                       required
                       [min]="form.get('schedule.startDate')?.value"
                       formControlName="endDate">
                <mat-datepicker-toggle matSuffix [for]="$any(recurringEndDatePicker)">
                </mat-datepicker-toggle>
                <ngx-mat-datetime-picker #recurringEndDatePicker
                                         [showSpinners]="true"
                                         [hideTime]="true"
                                         [color]="color"
                                         [enableMeridian]="true">
                  <ngx-mat-datepicker-actions>
                      <button color="primary" ngxMatDatepickerApply mat-icon-button
                          [attr.aria-label]="'form.button.select' | translate ">
                          <i class="tce-icon-checkmark"></i>
                      </button>
                  </ngx-mat-datepicker-actions>
                </ngx-mat-datetime-picker>
                <mat-error *ngIf="form.get('schedule.endDate').errors?.matDatetimePickerMin">
                  {{ 'coupons.rules.grid.edit.schedule.endDateMinError' | translate }}
                </mat-error>
                <mat-error *ngIf="!form.get('schedule.endDate').errors?.matDatetimePickerMin && (form.get('schedule.endDate').errors?.required || form.get('schedule.endDate').errors?.invalid)">
                  {{ 'coupons.rules.grid.edit.schedule.endDateRequired' | translate }}
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'coupons.rules.grid.edit.schedule.frequency.label' | translate }}</mat-label>
                <mat-select matInput
                            required
                            data-qa-label="FrequencySelect"
                            formControlName="frequency"
                            [(value)]="selectedFrequencyType"
                            placeholder="{{ 'coupons.rules.grid.edit.schedule.frequency.label' | translate }}">
                  <mat-option *ngFor="let frequency of frequencies"
                              [value]="frequency.value"
                              class="option">
                    <div class="option-name">{{ frequency.label }}</div>
                  </mat-option>
                </mat-select>
                <mat-error>
                  {{ 'form.error.required' | translate}}
                </mat-error>
              </mat-form-field>

              <mat-form-field [hidden]="selectedFrequencyType === 'MONTHLY'">
                <mat-label>{{ 'coupons.rules.grid.edit.schedule.frequencyModifier' | translate }}</mat-label>
                <mat-select matInput
                            [required]="selectedFrequencyType !== 'MONTHLY'"
                            data-qa-label="FrequencyModifierSelect"
                            formControlName="frequencyModifier"
                            placeholder="{{ 'coupons.rules.grid.edit.schedule.frequencyModifier' | translate }}">
                  <mat-option *ngFor="let modifier of frequencyModifiers"
                              [value]="modifier.value"
                              class="option">
                    <div class="option-name">{{ modifier.label }}</div>
                  </mat-option>
                </mat-select>
                <mat-error>
                  {{ 'form.error.required' | translate}}
                </mat-error>
              </mat-form-field>

              <mat-form-field *ngIf="selectedFrequencyType === 'MONTHLY'">
                <mat-label>{{ 'coupons.rules.grid.edit.schedule.dayOfMonth' | translate }}</mat-label>
                <mat-select matInput
                            required
                            data-qa-label="DayOfMonthSelect"
                            formControlName="dayOfMonth"
                            placeholder="{{ 'coupons.rules.grid.edit.schedule.dayOfMonth' | translate }}">
                  <mat-option *ngFor="let modifier of frequencyModifiers"
                              [value]="modifier.value"
                              class="option">
                    <div class="option-name">{{ modifier.label }}</div>
                  </mat-option>
                </mat-select>
                <mat-error>
                  {{ 'form.error.required' | translate}}
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'coupons.rules.grid.edit.schedule.timeOfDay' | translate }}</mat-label>

                <input matInput
                       type="time"
                       required
                       formControlName="timeOfDay">
                <mat-error *ngIf="form.get('schedule.timeOfDay').errors?.required || form.get('schedule.timeOfDay').errors?.invalid">
                  {{ 'coupons.rules.grid.edit.schedule.timeOfDayRequired' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngIf="form.get('type').value !== 'EVENT'">
            <div class="table-content">
              <table mat-table
                     [dataSource]="jobsData"
                     #matTable
                     matSort
                     (matSortChange)="setSorting($event)"
                     matSortDisableClear
                     [hidden]="isLoading"
                     class="jobs-list">
                <ng-container matColumnDef="startTime">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'coupons.rules.grid.edit.jobs.startTime' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let job">
                    {{ job.startTime | date: 'yyyy/MM/dd' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="finishedTime">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'coupons.rules.grid.edit.jobs.finishedTime' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let job">
                    {{ job.finishedTime | date: 'yyyy/MM/dd' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="audienceIds">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'coupons.rules.grid.edit.jobs.audienceIds' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let job">
                    {{ job.audienceIds.length }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'coupons.rules.grid.edit.jobs.status' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let job">
                    {{ job.status || 'NEW' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                  <td mat-cell *matCellDef="let job">
                    <div class="action-column">
                      <txp-button data-qa-label="RemoveButton"
                                  [style]="buttonStyle.ROWACTION"
                                  *ngIf="showRemoveJobButton(job)"
                                  icon="tce-icon-trash"
                                  class="remove-job-btn"
                                  [ngClass]="{ 'cancelling': cancellingJob && cancellingJob === job.id }"
                                  [attr.title]="'form.button.remove' | translate"
                        (click)="deleteJobDialog(job)">
                        <txp-loading *ngIf="cancellingJob && cancellingJob === job.id" [type]="loadingType.INLINE"></txp-loading>
                      </txp-button>
                      <txp-button data-qa-label="EditButton"
                                  [style]="buttonStyle.ROWACTION"
                                  *ngIf="showEditJobButton(job)"
                                  icon="tce-icon-edit"
                                  [attr.title]="'form.button.edit' | translate"
                                  (click)="onEditJob(job)">
                      </txp-button>
                    </div>
                  </td>
                </ng-container>

                <!-- footer for "loading" message -->
                <ng-container matColumnDef="loading">
                  <td mat-footer-cell *matFooterCellDef colspan="100">
                    <div>
                      <txp-loading [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading>
                      {{ 'rule.grid.loading' | translate }}
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
                <tr
                  mat-footer-row
                  *matFooterRowDef="['loading']; sticky: true"
                  [hidden]="!jobsLoading"
                ></tr>
              </table>
            </div>
          </ng-container>
        </div>
    </div>
</form>

<div class="actions">
  <txp-button (click)="onBack()"
              data-qa-label="BackButton"
              [style]="buttonStyle.PRIMARY">
    {{ 'form.button.back' | translate }}
  </txp-button>
  <txp-button [hidden]="rulesReadOnly"
              [style]="buttonStyle.SECONDARY"
              [disabled]="isSaving || (form.pristine && form.get('newJobs').value.length === 0)"
              data-qa-label="CancelButton"
              (click)="onCancel()">
    {{ 'form.button.cancel' | translate }}
  </txp-button>
  <txp-button [hidden]="rulesReadOnly"
              [style]="buttonStyle.PRIMARY"
              [disabled]="isSaving || (form.pristine && form.get('newJobs').value.length === 0)"
              [loading]="isSaving"
              data-qa-label="SaveButton"
              (click)="onSave()">
    {{ (newDistributionRule ? 'form.button.create' : 'form.button.save') | translate }}
  </txp-button>
</div>

